import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { LongHaulRequest, LongHaulRequestMeasurementCommitteeDecision, ReleaseOpject, LongHaulDefineRebate, AknowledgeReceiveRequest, LongHaulReviewRebate, LongHaulRequestFormulateDecision, LongHaulRequestAccurateDataForm, LongHaulRequestMarkRefunded, LongHaulRequestConfirmShipPassing, LongHaulRequestReleaseRebate, ReleaseFormStartWFDTO, ReleaseRefundRequestDTO, ReleaseRefundAdminDTO ,ReleaseRestudyAdminDTO} from '../models/long-haul.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LongHaulService {

    constructor(private http: HttpServices, private _http: HttpClient) { }

  //Requestor
  submitRebateRequest(longHaulRequest: LongHaulRequest) {
    return this.http.post('LongHaul/SubmitRebateRequest', longHaulRequest);
  }
  submitReleaseRequest(Request: ReleaseOpject) {
    return this.http.post('LongHaul/submitReleaseRequest', Request);
  }
  EditReleaseRequest(Request: ReleaseOpject) {
    return this.http.post('LongHaul/EditReleaseForm', Request);
  }
  checkIMOExistingValidRebate(pIMONO: String) {
    return this.http.get('LongHaul/CheckIMOExistingValidRebate?pIMONO=' + pIMONO);
  }
  submitEditedRebateRequest(longHaulRequest: LongHaulRequest) {
    return this.http.post('LongHaul/SubmitEditedRebateRequest', longHaulRequest);
  }
  submitRequestorDecision(longHaulRequestFormulateDecision: LongHaulRequestFormulateDecision) {
    return this.http.post('LongHaul/RequestorDecision', longHaulRequestFormulateDecision);
  }
  getRequestorDecision(longHaulRequestFormulateDecision: LongHaulRequestFormulateDecision) {
    return this.http.post('LongHaul/GetRequestorDecision', longHaulRequestFormulateDecision);
  }
  getRequestTimeBeforeSailingDate() {
    return this.http.get('LongHaul/GetRequestTimeBeforeSailingDate');
  }
  restudy(longHaulRequestId: String, AdminEmail: string) {
    return this.http.get('LongHaul/Restudy?longHaulRequestId=' + longHaulRequestId + '&AdminEmail=' + AdminEmail);
  }
  //Admin
  //Economic Committee
  aknowledgeReceiveRequest(aknowledgeReceiveRequestDTO: AknowledgeReceiveRequest) {
    return this.http.post('LongHaul/AknowledgeReceiveRequest', aknowledgeReceiveRequestDTO);
  }
  getAknowledgeReceiveRequest(longHaulRequestId: String) {
    return this.http.get('LongHaul/GetAknowledgeReceiveRequest?longHaulRequestId=' + longHaulRequestId);
  }
  defineRebate(longHaulDefineRebate: LongHaulDefineRebate) {
    return this.http.post('LongHaul/DefineRebate', longHaulDefineRebate);
  }
  editDefineRebate(longHaulDefineRebate: LongHaulDefineRebate) {
    return this.http.post('LongHaul/EditDefineRebate', longHaulDefineRebate);
  }
  getRebateRequestToFormulateDecision(longHaulRequestFormulateDecision: LongHaulRequestFormulateDecision) {
    return this.http.post('LongHaul/GetRebateRequestToFormulateDecision', longHaulRequestFormulateDecision);
  }
  formulateDecision(longHaulRequestFormulateDecision: LongHaulRequestFormulateDecision) {
    return this.http.post('LongHaul/FormulateDecision', longHaulRequestFormulateDecision);
  }
  getFormulatedDecision(longHaulRequestId: String) {
    return this.http.get('LongHaul/GetFormulatedDecision?longHaulRequestId=' + longHaulRequestId);
  }
  exportOptionsDataExcel(longHaulRequest: LongHaulRequest) {
    return this.http.post('LongHaul/ExportOptionsDataExcel', longHaulRequest);
  }
  //Measurement Committee
  submitMeasurementCommitteeDecision(longHaulRequestMeasurementCommitteeDecision: LongHaulRequestMeasurementCommitteeDecision) {
    return this.http.post('LongHaul/SubmitMeasurementCommitteeDecision', longHaulRequestMeasurementCommitteeDecision);
  }
  reviewRebate(longHaulReviewRebate: LongHaulReviewRebate) {
    return this.http.post('LongHaul/ReviewRebate', longHaulReviewRebate);
  }
  getRelatedRequests(pIMONO: String, longHaulRequestId: String) {
    return this.http.get('LongHaul/GetRelatedRequests?pIMONO=' + pIMONO + '&longHaulRequestId=' + longHaulRequestId);
  }
  getMeasurementAcceptRebateRequest(pIMONO: String) {
    return this.http.get('LongHaul/GetMeasurementAcceptRebateRequest?pIMONO=' + pIMONO);
  }
  //Shared
  getRebateRequest(longHaulRequestId: string) {
    return this.http.get('LongHaul/GetRebateRequest?longHaulRequestId=' + longHaulRequestId);
  }
  GetReleaseForm(longHaulRequestId: string) {
    return this.http.get('LongHaul/GetReleaseForm?RequestId=' + longHaulRequestId);
  }
  GetReleaseFormByFormID(longHaulRequestId: string) {
    return this.http.get('LongHaul/GetReleaseFormByFormID?RequestId=' + longHaulRequestId);
  }
  GetReleaseFormData(longHaulRequestId: string) {
    return this.http.get('LongHaul/GetReleaseFormData?longHaulRequestId=' + longHaulRequestId);
  }
  getMeasurementDecisionRebateRequest(longHaulRequestId: string) {
    return this.http.get('LongHaul/GetMeasurementDecisionRebateRequest?longHaulRequestId=' + longHaulRequestId);
  }
  getDefineRebate(longHaulDefineRebate: LongHaulDefineRebate) {
    return this.http.post('LongHaul/GetDefineRebate', longHaulDefineRebate);
  }
  getActiveRequestsPagedSorted(pageIndex: number, pageSize: number, sortBy: string, sortDirection: string, searchTerm: string) {
    return this.http.get('LongHaul/GetActiveRequestsPagedSorted?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&sortBy=' + sortBy + '&sortDirection=' + sortDirection + '&searchTerm=' + searchTerm);
  }
  submitAccurateDataForm(longHaulRequestAccurateDataForm: LongHaulRequestAccurateDataForm) {
    return this.http.post('LongHaul/SubmitAccurateDataForm', longHaulRequestAccurateDataForm);
  }
  getAccurateDataForm(longHaulRequestId: string) {
    return this.http.get('LongHaul/GetAccurateDataForm?longHaulRequestId=' + longHaulRequestId);
  }
  editAccurateDataForm(longHaulRequestAccurateDataForm: LongHaulRequestAccurateDataForm) {
    return this.http.post('LongHaul/EditAccurateDataForm', longHaulRequestAccurateDataForm);
  }
  markRefunded(longHaulRequestMarkRefunded: LongHaulRequestMarkRefunded) {
    return this.http.post('LongHaul/MarkRefunded', longHaulRequestMarkRefunded);
  }
  getMarkRefunded(longHaulRequestId: string) {
    return this.http.get('LongHaul/GetMarkRefunded?longHaulRequestId=' + longHaulRequestId);
  }
  confirmShipPassing(longHaulRequestConfirmShipPassing: LongHaulRequestConfirmShipPassing) {
    return this.http.post('LongHaul/ConfirmShipPassing', longHaulRequestConfirmShipPassing);
  }
  getConfirmShipPassing(longHaulRequestId: string) {
    return this.http.get('LongHaul/GetConfirmShipPassing?longHaulRequestId=' + longHaulRequestId);
  }
  releaseRebate(longHaulRequestReleaseRebate: LongHaulRequestReleaseRebate) {
    return this.http.post('LongHaul/ReleaseRebate', longHaulRequestReleaseRebate);
  }
  getReleaseRebate(longHaulRequestReleaseRebate: LongHaulRequestReleaseRebate) {
    return this.http.post('LongHaul/GetReleaseRebate', longHaulRequestReleaseRebate);
  }
  GetValidRequests(pIMONO: String, agentEmail: String) {
    // return this.http.get('LongHaul/GetValidRequests?pIMONO=' + pIMONO + '&agentEmail=' + agentEmail);
    return this.http.get('Circulars/GetValidRequests?pIMONO=' + pIMONO + '&agentEmail=' + agentEmail);
  }

  StartRefundWorflow(releaseFormStart: ReleaseFormStartWFDTO) {
    return this.http.post('Refund/StartRefundWorflow', releaseFormStart);
  }
  StartRestudyWorkflow(releaseFormStart: ReleaseFormStartWFDTO) {
    return this.http.post('Restudy/StartRestudyWorkflow', releaseFormStart);
  }
  GetNextStepUsers(groupName: string) {
    return this.http.get('SPGroupUser/GetSPUsersByGroupName?groupName=' + groupName);
  }
  GetRefundRequestById(baseRequestId: String) {
    return this.http.get('Refund/GetRefundRequestById?baseRequestId=' + baseRequestId);
  }
  GetRestudyRequestById(baseRequestId: String) {
    return this.http.get('Restudy/GetRestudyRequestById?baseRequestId=' + baseRequestId);
  }
  SubmitRefundMeasFirstReviewerDecision(refundAdminObj: ReleaseRefundAdminDTO) {
    return this.http.post('Refund/SubmitRefundMeasFirstReviewerDecision', refundAdminObj);
  }
  SubmitRestudyMeasFirstReviewerDecision(refundAdminObj: ReleaseRestudyAdminDTO) {
    return this.http.post('Restudy/SubmitRestudyMeasFirstReviewerDecision', refundAdminObj);
  }
  SubmitRestudyMeasFirstReviewerCancellationDecision(refundAdminObj: ReleaseRestudyAdminDTO) {
    return this.http.post('Restudy/SubmitRestudyMeasFirstReviewerCancellationDecision', refundAdminObj);
  }
  SubmitRestudyMeasManagerCancellationDecision(refundAdminObj: ReleaseRestudyAdminDTO) {
    return this.http.post('Restudy/SubmitRestudyMeasManagerCancellationDecision', refundAdminObj);
  }
  SubmitRestudyMeasManagerDecision(refundAdminObj: ReleaseRestudyAdminDTO) {
    return this.http.post('Restudy/SubmitRestudyMeasManagerDecision', refundAdminObj);
  }
  SubmitEconomicDecision(refundAdminObj: ReleaseRestudyAdminDTO) {
    return this.http.post('Restudy/SubmitEconomicDecision', refundAdminObj);
  }
  SubmitEconomicManagerDecision(refundAdminObj: ReleaseRestudyAdminDTO) {
    return this.http.post('Restudy/SubmitEconomicManagerDecision', refundAdminObj);
  }
  SubmitCancelRebateWorkflow(refundAdminObj: ReleaseRestudyAdminDTO) {
    return this.http.post('Restudy/SubmitCancelRebateWorkflow', refundAdminObj);
  }
  SubmitRefundMeasSecondReviewerDecision(refundAdminObj: ReleaseRefundAdminDTO) {
    return this.http.post('Refund/SubmitRefundMeasSecondReviewerDecision', refundAdminObj);
  }
  SubmitRefundMeasManagerDecision(refundAdminObj: ReleaseRefundAdminDTO) {
    return this.http.post('Refund/SubmitRefundMeasManagerDecision', refundAdminObj);
  }
  SubmitRefundEunitApprovalDecision(refundAdminObj: ReleaseRefundAdminDTO) {
    return this.http.post('Refund/SubmitRefundEunitApprovalDecision', refundAdminObj);
  }
  SubmitDeputyManagerApprovalDecision(refundAdminObj: ReleaseRefundAdminDTO) {
    return this.http.post('Refund/SubmitDeputyManagerApprovalDecision', refundAdminObj);
  }
  SubmitManagerApprovalDecision(refundAdminObj: ReleaseRefundAdminDTO) {
    return this.http.post('Refund/SubmitManagerApprovalDecision', refundAdminObj);
  }
  SubmitMeasurementPrintDecision(refundAdminObj: ReleaseRefundAdminDTO) {
    return this.http.post('Refund/SubmitMeasurementPrintDecision', refundAdminObj);
  }
    // getLongHaulReleaseCreator(creatorEmail: string) {
    //     return this.http.get('SPGroupUser/GetSPGroupByUserEmail?email=' + creatorEmail);
    // }
    getReleaseWFSubmittedAdmins(requestId: string, role: string) {
        return this.http.get('ReleaseWFSubmittedAdmins/GetReleaseWFSubmittedAdmins?baseRequestId=' + requestId + '&role=' + role);
    }
    public GetArabicNames() {
      return this.http.get("LongHaul/GetArabicNames");
    }
}

